import { Application } from "stimulus"
import { definitionsFromContext } from "stimulus/webpack-helpers"

# Make property definition available globally.
Function::property = (prop, desc) ->
  Object.defineProperty @prototype, prop, desc

application = Application.start()
context = require.context("controllers", true, /\.js|\.coffee|\.coffee\.erb$/)
application.load(definitionsFromContext(context))